module.exports = __webpack_public_path__ + "static/media/number3.32f37f72.webp";